/**
 * Operator groups for computed-kind FieldTypes.
 *
 * Subtypes inherit from their parent via the chain walk in `../operators`.
 */

import type { OperatorGroup } from "./index.js"
import { isEmpty, isNotEmpty } from "./presence.js"

const presence: OperatorGroup = { label: "Presence", operators: [isEmpty, isNotEmpty] }

export const operatorGroups: Record<string, OperatorGroup[]> = {
  lookup: [presence],
}
